import { create } from 'zustand';
import type { Achievements } from '~/features/stamps/achievements/types/enums';

interface AchievementState {
  // 子IDごとにアチーブメント配列を管理
  achievements: Record<number, Achievements[]>;
  addAchievement: (childId: number, achievement: Achievements) => void;
  removeAchievement: (childId: number, achievement: Achievements) => void;
}

export const useAchievementStore = create<AchievementState>((set) => ({
  achievements: {},
  addAchievement: (childId, achievement) =>
    set((state) => ({
      achievements: {
        ...state.achievements,
        [childId]: [...(state.achievements[childId] ?? []), achievement],
      },
    })),
  removeAchievement: (childId, achievement) =>
    set((state) => ({
      achievements: {
        ...state.achievements,
        [childId]: (state.achievements[childId] ?? []).filter((prev) => prev !== achievement),
      },
    })),
}));
